import { render } from "./walk-to-remember.vue?vue&type=template&id=0838b622&scoped=true"
import script from "./walk-to-remember.vue?vue&type=script&lang=js"
export * from "./walk-to-remember.vue?vue&type=script&lang=js"

import "./walk-to-remember.vue?vue&type=style&index=0&id=0838b622&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0838b622"]])

export default __exports__